import axios from "axios";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../constants/AlertProvider";

export default function ProtectedRoutes({ children, allowedRoles }) {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();
  const showAlert = useAlert();

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const response = await axios.get("/api/session/", { withCredentials: true });
        if (response.data.isAuthenticated) {
          const userId = Cookies.get("id");
          if (userId) {
            const userResponse = await axios.get(`/api/users/${userId}/`, { withCredentials: true });
            const role = userResponse.data.role;
            setUserRole(role);

            if (allowedRoles.includes(role)) {
              setIsAuthorized(true);
            } else {
              // Role conflict detected. Log out the user.
              setIsAuthorized(false);
              showAlert("Session conflict detected. Please log in with the correct account.", "error");
              await axios.post("/api/logout/", {}, { withCredentials: true });
              navigate("/login", { replace: true, state: { from: 'session-conflict' } });
            }
          } else {
            setIsAuthorized(false);
            showAlert("Your session has expired. Please log in again.", "error");
            navigate("/login", { replace: true });
          }
        } else {
          setIsAuthorized(false);
          // No active session, just redirect.
          navigate("/login", { replace: true });
        }
      } catch (error) {
        console.error("Authorization check failed:", error);
        setIsAuthorized(false);
        showAlert("An error occurred during authentication. Please log in again.", "error");
        navigate("/login", { replace: true });
      }
    };

    checkAuthorization();
  }, [allowedRoles, navigate]);

  if (isAuthorized === null) {
    return (
      <div className="flex items-center justify-center h-screen w-screen">
        <div className="flex flex-col items-center space-y-2">
          <div className="loader"></div>
        </div>
      </div>
    );
  }

  return isAuthorized ? children : <div className="flex flex-col items-center justify-center h-screen">
    <p className="text-4xl text-gray-400">Oops!</p>
    <p className="text-2xl text-gray-400">Something went wrong.</p>
  </div>;
}

ProtectedRoutes.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};